<script setup>
import {computed, ref} from "vue";
import {useDisplay} from "vuetify";

const props = defineProps(['qrData','width','clickTrigger','downloadName'])

const qr_code = ref(null)
const showPreview = ref(false)

const digitCode = computed(()=> {
  const digitCodeString = props.qrData.toString()
  if (digitCodeString.length === 6) {
    return digitCodeString.slice(0, 3) + ' ' + digitCodeString.slice(3)
  }
  return digitCodeString
})

const options = {
  width: props.width ? props.width : 100,
  color: {
    dark: '#000000',
    light: '#fffefe',
  },
}

const bigSizeOptions = {
  ...options,
  width: useDisplay().height.value - 190
}

/**
 * Trigger download of QR code image.
 */
// eslint-disable-next-line
function downloadQRCode() {
  if(props.clickTrigger){
    const download = document.createElement('a');
    download.href = qr_code.value.src;
    download.download = props.downloadName ? props.downloadName : null;
    download.click()
  }
}

</script>

<template>
  <div class="d-flex flex-column justify-center align-center cursor-pointer"
       @click="showPreview = true"
  >
      <vue-qrcode
          style="border: #7BB916 solid 4px; border-radius: 10%"
          ref="qr_code"
          :value="props.qrData"
          :options="options"
          tag="img"
      ></vue-qrcode>
    <div
        class="font-weight-light text-grey-darken-3 pt-2"
        style="font-size: 0.8em"
    >
      {{ $t('gamification.click_to_view_preview') }}
    </div>
  </div>
  <v-dialog
      v-model="showPreview"
      width="auto"
  >
    <v-card>
      <div class="d-flex flex-column justify-center align-center">
        <vue-qrcode
            ref="qr_code"
            :value="props.qrData"
            :options="bigSizeOptions"
            tag="img"
        ></vue-qrcode>
        <span class="font-weight-black" style="letter-spacing: 0.0892857143em; font-size: 3.5em"> {{ digitCode }} </span>
      </div>
      <template v-slot:actions>
        <v-spacer></v-spacer>
        <v-btn
            @click="showPreview = false"
            variant="text"
            color="primary"
        >
          {{ $t('entities.close') }}
        </v-btn>
      </template>
    </v-card>
  </v-dialog>
</template>

<style scoped>

</style>